import { filestackPath } from 'lib/helpers/utility';

const { default: jsPDF } = require('jspdf');
const { default: autoTable } = require('jspdf-autotable');

const exportToPdf = (data, title, practice) => {
  if (!data || data.length === 0) return;

  const columnHeaders = Object.keys(data[0]);
  const columnCount = columnHeaders.length;
  const pageWidth = 210 - 28; // A4 width minus margins
  const columnWidth = pageWidth / columnCount;
  const rows = data.map((row) => Object.values(row).map((value) => value ?? ''));

  const doc = new jsPDF();
  const pageHeight = doc.internal.pageSize.height;

  // Create a filename
  const fileName = `${title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`;

  // Set PDF metadata
  doc.setProperties({
    title: fileName
  });

  let startY = 20;

  // Add header image or text
  if (practice?.header_photo) {
    const headerPhotoData = JSON.parse(practice.header_photo);
    doc.addImage(filestackPath(headerPhotoData.jpg), 'JPEG', 14, 10, 50, 30);
    startY = 45;
  } else {
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text(title, 14, 10);

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Report generated: ${fileName}`, 14, 16);
    startY = 22;
  }

  // Add table
  autoTable(doc, {
    head: [columnHeaders],
    body: rows,
    startY,
    styles: {
      fontSize: 10,
      cellPadding: 2,
      overflow: 'linebreak'
    },
    headStyles: {
      fillColor: '#004F6B'
    },
    columnStyles: columnHeaders.reduce((acc, _, i) => {
      acc[i] = {
        cellWidth: columnWidth,
        overflow: 'linebreak'
      };
      return acc;
    }, {}),
    didDrawPage: () => {
      const printDate = new Date().toLocaleString();
      doc.setFontSize(8);
      const dateText = `Print date: ${printDate}`;
      const dateTextWidth = doc.getStringUnitWidth(dateText) * 3;
      doc.text(dateText, pageWidth - dateTextWidth - 10, pageHeight - 10);
    }
  });

  // Add page numbers
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    const pageText = `${i} of ${totalPages}`;
    const pageTextWidth = doc.getStringUnitWidth(pageText) * 3;
    doc.text(pageText, (pageWidth - pageTextWidth) / 2, pageHeight - 10);
  }

  // Create blob and URL
  const pdfBlob = doc.output('blob');
  const pdfURL = URL.createObjectURL(pdfBlob);

  // Create hidden iframe for printing
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = pdfURL;
  document.body.appendChild(iframe);

  iframe.onload = function () {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // No auto-download, just clean up
    URL.revokeObjectURL(pdfURL);
    // setTimeout(() => document.body.removeChild(iframe), 1000);
  };
};

export default exportToPdf;
